import { parse as queryParse, stringify } from 'qs';

const parse = (search) => (
  queryParse(search, { ignoreQueryPrefix: true })
);

export { parse, stringify };
